const ua = navigator.userAgent.toLowerCase()

const isIos = ((): boolean => {
  return !!ua.includes('iphone') || !!ua.includes('ipad') || (/mac os/.test(ua) && document.ontouchstart !== undefined)
})

const isAndroid = ((): boolean => {
  return !!ua.includes('android')
})

const isWindows = ((): boolean => {
  return ua.includes('windows nt')
})

const isMacOs = ((): boolean => {
  return ua.includes('mac os x')
})

export default {
  isIos,
  isAndroid,
  isWindows,
  isMacOs,
}
